import { render, staticRenderFns } from "./myTrial.vue?vue&type=template&id=c879bd70&scoped=true"
import script from "./myTrial.vue?vue&type=script&lang=js"
export * from "./myTrial.vue?vue&type=script&lang=js"
import style0 from "./myTrial.vue?vue&type=style&index=0&id=c879bd70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c879bd70",
  null
  
)

export default component.exports